export default {
  nav: {
    home: 'Početna',
    video: 'Videonadzor',
    alarm: 'Alarmni sustavi',
    solutions: 'Rješenja',
    care: 'SSG Care',
    planner: 'Planer kamera',
    areas: 'Područja usluge',
    about: 'O nama',
    contact: 'Kontakt',
  },
  dropdown: {
    allSolutions: 'Pogledaj sva rješenja',
    homeGrounds: 'Dom i okućnica',
    retailGastro: 'Maloprodaja i ugostiteljstvo',
    officePractice: 'Ured i ordinacija',
    warehouseLogistics: 'Skladište i logistika',
    workshopTrade: 'Radionica i obrt',
    apartments: 'Višestambene zgrade i nekretnine',
    cameraTypes: 'Vrste kamera',
    services: 'Usluge',
    technology: 'Tehnika',
  },
  footer: {
    brandLine: 'Sigurnosna tehnika za privatne i poslovne korisnike',
    area: 'Hainburg · Rajna-Majna regija',
    services: 'Usluge',
    solutions: 'Rješenja',
    forWhom: 'Za koga',
    contact: 'Kontakt',
    areaLabel: 'Područje usluge Rajna-Majna',
    privateCustomers: 'Privatni korisnici',
    businessCustomers: 'Poslovni korisnici',
    allSolutions: 'Sva rješenja',
    faq: 'Česta pitanja',
    rights: 'Sva prava pridržana.',
    impressum: 'Impressum',
    privacy: 'Zaštita podataka',
    cookieSettings: 'Postavke kolačića',
  },
  related: {
    eyebrow: 'Više rješenja',
    title: 'Otkrijte druge vrste objekata',
    viewAll: 'Pogledajte sva rješenja',
  },
};